import React from "react";
import styled from "styled-components";
import { Input } from "@rebass/forms/styled-components";
import { Box } from "rebass/styled-components";

import theme from "../../../../theme/themeThree";

const FakeLabel = styled.div<{ error?: string }>`
  position: absolute;
  color: ${(props) =>
    props.error
      ? props.theme.colors.error
      : props.theme.colors[props.theme.input["::placeholder"].color]};
  opacity: 0;
  visibility: hidden;
  line-height: ${(props) => props.theme.variants.input.default.lineHeight};
  transition: font-size ${(props) => props.theme.transitionDuration},
    top ${(props) => props.theme.transitionDuration},
    line-height ${(props) => props.theme.transitionDuration},
    background-color ${(props) => props.theme.transitionDuration};
  top: 0;
  padding: 0 5px;
  left: ${(props) =>
    props.theme.space[props.theme.variants.input.default.px] - 5}px;

  background: ${(props) => props.theme.input.bg};
  visibility: visible;
  font-size: 0.8em;
  &:hover {
    cursor: default;
  }
  opacity: 1;
  top: -0.8em;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 2px;
  padding-bottom: 3px;
  line-height: 1em;
  box-shadow: 0px 1px 4px
      ${(props) => props.theme.colors[props.theme.input["::boxshadow"].color]};
  }
`;

const StyledInput = styled(Input)`
  &:disabled {
    cursor: default;
  }
`;

interface ILabelReadyOnly {
  text?: string;
  label?: string;
}

export const LabelReadOnly = ({ text, label }: ILabelReadyOnly) => {
  return (
    <>
      <Box style={{ position: "relative", width: "100%" }}>
        <StyledInput
          sx={{
            ...theme.input,
            ...theme.labeledInput,
            ...theme.variants.input["default"],
          }}
          type="text"
          placeholder={text}
          disabled={true}
          readOnly={true}
        />
        {label ? <FakeLabel>{label}</FakeLabel> : null}
      </Box>
    </>
  );
};
